module.exports = "<button class=\"default\" [ngClass]=\"inputClass\"></button>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/background-btn.component/background-btn.component.html
// module id = ./src/app/shared/components/background-btn.component/background-btn.component.html
// module chunks = main